import React from 'react';
import { connect } from 'react-redux';
import VideoSearch from '../components/VideoSearch.js';
import { firebase, database } from '../firebase.js';

const YouTube = require('youtube-node');
const youTube = new YouTube();
youTube.setKey('AIzaSyCUwAcEmXTz1yJ14G2PPt-Z5XRwaWad37Q');

const fetchVideos = (query) => {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      youTube.search(query, 25, function(error, result) {
        if (error) {
          reject(error);
        }
        else {
          resolve(result)     
        }
      });
    }).then(
      results => dispatch({
        type: 'CHANGE_VIDEOS',
        results: results.items,
      })
    )
  }
}

const mapStateToProps = state => {
  return {
    videos: state.videoSearch.videos,
    filter: state.videoSearch.filter,
    playlist: state.videoSearch.playlist,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFilterChange: (filter) => {
      dispatch({
        type: 'CHANGE_FILTER',
        filter
      })
    },
    onVideoUpdate: (filter) => {
      dispatch(fetchVideos(filter))
    },
    onVideoAdd: (title, id) => {
      const videoData = {
        title,
        id,
      }
      var newVideoKey = firebase.database().ref().child('playlist').push();
      newVideoKey.set(videoData);
      dispatch({
        type: 'ADD_VIDEO',
        id,
      })
    }
  }
}

const VideoQuery = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VideoSearch)

export default VideoQuery



// WEBPACK FOOTER //
// ./src/containers/VideoQuery.js